export default "__VITE_ASSET__1dc35ee3__"